(function() {

	'use strict';

	/**
	 * Selectors
	 */

	// DOM elements
	var body = document.body;
	// var themeSong = document.querySelector('[data-themeSong]');
	var scrollFadeIn = document.querySelectorAll('[data-fade-in]');
	var scrollParallaxOut = document.querySelectorAll('[data-parallax-out]');
	var collage = document.querySelectorAll('[data-collage]');

	// Classes
	var activeClass = 'is-active';
	var inactiveClass = 'is-inactive';

	// States
	// var themeSongActive = true;

	// Greensock Tweens
	var tweens = {
		// theme: {
		// 	toggle: document.querySelector('[data-play="theme"]'),
		// 	audio: document.querySelector('[data-song="theme"]')
		// },
		shoutBamalama: {
			toggle: document.querySelector('[data-play="shoutBamalama"]'),
			audio: document.querySelector('[data-song="shoutBamalama"]'),
			animation: new TimelineMax(),
			scene: document.querySelector('#shoutBamalama')
		},
		dockOfBay: {
			toggle: document.querySelector('[data-play="dockOfBay"]'),
			audio: document.querySelector('[data-song="dockOfBay"]'),
			animation: new TimelineMax(),
			scene: document.querySelector('#dockOfBay')
		}
	};

	// TimelineMax functions
	var controller = new ScrollMagic.Controller();


	/**
	 * Methods
	 */

	// forEach helper
	var forEach = function ( collection, callback, scope ) {
		if ( Object.prototype.toString.call( collection ) === '[object Object]') {
			for ( var prop in collection ) {
				if ( Object.prototype.hasOwnProperty.call( collection, prop )) {
					callback.call( scope, collection[prop], prop, collection );
				}
			}
		} else {
			for (var i = 0, len = collection.length; i < len; i++) {
				callback.call(scope, collection[i], i, collection);
			}
		}
	};

	// Get closets matching parent
	var getClosest = function (elem, selector) {
		var firstChar = selector.charAt(0);
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( firstChar === '.' ) {
				if ( elem.classList.contains( selector.substr(1) ) ) {
					return elem;
				}
			}
			if ( firstChar === '#' ) {
				if ( elem.id === selector.substr(1) ) {
					return elem;
				}
			}
			if ( firstChar === '[' ) {
				if ( elem.hasAttribute( selector.substr(1, selector.length - 2) ) ) {
					return elem;
				}
			}
			if ( elem.tagName.toLowerCase() === selector ) {
				return elem;
			}
		}
		return false;
	};

	// Load SVG sprite
	var loadSVG = function() {
		var ajax = new XMLHttpRequest();
		ajax.open('GET', '/sprite.svg', true);
		ajax.send();
		ajax.onload = function() {
			var div = document.createElement('div');
			div.style.display = 'none';
			div.innerHTML = ajax.responseText;
			document.body.insertBefore(div, document.body.childNodes[0]);
		};
	};

	// Remove quotes from string
	var removeQuotes = function(string) {
		if (typeof string === 'string' || string instanceof String) {
			string = string.replace(/^['"]+|\s+|\\|(;\s?})+|['"]$/g, '');
		}
		return string;
	};

	// Detect active CSS media queries
	var checkMedia = function() {
		var media = window.getComputedStyle( document.body,':after' ).getPropertyValue( 'content' );
		return removeQuotes( media );
	};

	// Pause active songs
	var pauseMusic = function(elem) {
		if(elem) {
			for(var key in tweens) {
				if (!tweens[key].audio.paused && tweens[key].audio !== elem) {
					tweens[key].audio.pause();
				}
			}
		} else {
			for(key in tweens) {
				if (!tweens[key].audio.paused) {
					tweens[key].audio.pause();
				}
			}
		}
	};

	// Pause active animations
	var pauseAnimation = function(elem) {
		if (elem) {
			for(var key in tweens) {
				if (tweens[key].animation && tweens[key].animation.isActive() && key !== elem) {
					tweens[key].animation.pause();
					updateToggle(tweens[key].toggle);
				}
			}
		} else {
			for(key in tweens) {
				if (tweens[key].animation && tweens[key].animation.isActive()) {
					tweens[key].animation.pause();
					updateToggle(tweens[key].toggle);
				}
			}
		}
	};

	// Toggle animation state
	var toggleAnimation = function(elem) {
		if (tweens[elem].animation) {

			// If animation is active
			if(tweens[elem].animation.isActive()) {

				// Pause animation
				tweens[elem].animation.pause();

				// Set animation state
				body.classList.remove('animation-is-active');

			// If animation is paused
			} else if (tweens[elem].animation.paused()) {

				// Resume animation
				tweens[elem].animation.resume();

				// Set animation state
				body.classList.add('animation-is-active');

			// If animation was not be initiated
			} else {

				// Init animation
				recordTweenInit(tweens[elem].scene, tweens[elem].animation);

				// Set animation state
				body.classList.add('animation-is-active');
			}
		}
	};

	// Toggle Song
	var toggleSong = function(toggle, elem) {

		// Toggle themeSong state
		// if (elem === themeSong) {
		// 	if (themeSongActive) {
		// 		themeSongActive = false;
		// 	} else {
		// 		themeSongActive = true;
		// 	}
		// }

		// Pause any music playing
		pauseMusic(elem);

		// Toggle state of selected track
		if (elem.paused) {
			elem.play();
			toggle.classList.remove(inactiveClass);
		} else {
			elem.pause();
			toggle.classList.add(inactiveClass);

			// Resume playing theme song
			// if (themeSongActive) {
			// 	themeSong.play();
			// }
		}
	};

	// Update song toggle element
	var updateToggle = function(toggle) {

		// Get child elements
		var activeToggle = toggle.querySelector('[data-toggle-active]');
		var inactiveToggle = toggle.querySelector('[data-toggle-inactive]');

		// Toggle states
		activeToggle.classList.toggle('hidden');
		inactiveToggle.classList.toggle('hidden');
	};

	// Handle click events
	var clickEventHandler = function(e) {

		// Get closest anchor
		var anchor = getClosest( e.target, 'a' );

		// Music/animation trigger
		if (anchor && anchor.hasAttribute('data-play')) {

			// Prevent link default
			e.preventDefault();

			// Get song name
			var name = anchor.getAttribute('data-play');

			// Pause All Animations
			pauseAnimation(name);

			// Toggle song audio
			toggleSong(anchor, tweens[name].audio);

			// Play, pause or init animation
			toggleAnimation(name);

			// Update toggle
			updateToggle(tweens[name].toggle);
		}

		// Smooth scroll trigger
		if (anchor && anchor.hasAttribute('data-smooth-scroll')) {
			e.preventDefault();
			var target = anchor.getAttribute('href');
			TweenMax.to(window, 0.4, {scrollTo: target});
		}

		// Spotify Playlist
		if (getClosest( e.target, '#playlist' )) {
			console.log(e.target);
		}
  };
  
  // Handle keyup events
  var keyupEventHandler = function(e) {
    var key = e.key;
    
    // Stop video playback on Esc key press
    if (key === 'Escape') {
      var videos = document.querySelectorAll('iframe');
      videos.forEach(function(element) {
        element.src = element.src.replace('&autoplay=1', '');
      });
    }
  };

	// Handle end events
	var endedEventHandler = function(e) {

		// Get audio ID
		var audio = e.target;
		var name = audio.getAttribute('data-song');

		console.log(name);

		if (name !== 'theme') {

			// Reset corresponding animation scene
			tweens[name].animation.restart().pause();

			// Update toggle
			updateToggle(tweens[name].toggle);

			// Resume playing theme song
			// if (themeSongActive) {
			// 	themeSong.play();
			// }

		}
	};

	// Handle lazysizes unveil event
	var lazyBeforeUnveilHandler = function(e) {
		var elem = e.target;

		// Gallery images
		if (elem.hasAttribute('data-gallery-img')) {
			var gallery = getClosest(elem, '[data-gallery]');
			var flkty = Flickity.data(gallery);

			if (!flkty) {
				new Flickity(gallery, {
					imagesLoaded: true,
					cellAlign: 'left',
					pageDots: false,
					prevNextButtons: false,
					wrapAround: true
				});
			} else {
				return;
			}
		}
	};

	// Record player animation
	var recordTweenInit = function(sceneEl, tweenName) {

		// Get DOM elements
		var cover = sceneEl.querySelector('.cover');
		var base = sceneEl.querySelector('.base');
		var arm = sceneEl.querySelector('.arm');
		var record = sceneEl.querySelector('.record');

		// Animate elements
		tweenName.to(cover, 1, {x: '-=150%', ease: Power2.easeOut})
		.to(base, 0.5, {opacity: 1, ease: Power2.easeOut}, '-=1')
		.to(arm, 0.5, {rotation: '8deg', opacity: 1, transformOrigin: 'right 15%', ease: Power2.easeOut}, '-=1')
		.to(record, 1.5, {rotation: 360, transformOrigin: 'center center', repeat:-1, ease: Power0.easeNone}, '0.5')
		.to(arm, 400, {rotation: '30deg', transformOrigin: 'right 10%', ease: Power2.easeOut, delay: 2}, '0');
	};


	/**
	 * Events/APIs/init
	 */

	// Check CSS Media Queries
	checkMedia();

	// Init ScrollMagic: FadeIn
	forEach(scrollFadeIn, function (index) {
		new ScrollMagic.Scene({
			triggerElement: index,
			triggerHook: 0.6,
			duration: '100%'
		})
		.setClassToggle(index, activeClass)
		.addTo(controller);
	});

	// Init ScrollMagic: Parallax and fade out
	if (checkMedia() === 'small') {
		forEach(scrollParallaxOut, function (index) {
			new ScrollMagic.Scene({
				triggerElement: index,
				triggerHook: 0.1,
				duration: '50%'
			})
			.setTween(index, {y: '20%', opacity: '0', ease: Linear.easeNone})
			.addTo(controller);
		});
	}

	// Init ScrollMagic: Collages
	if (checkMedia() === 'small') {
		forEach(collage, function (index) {
			new ScrollMagic.Scene({
				triggerElement: index,
				triggerHook: 1,
				duration: '200%'
			})
			.setTween(index.children, {y: '30%', ease: Linear.easeNone})
			.addTo(controller);
		});
	}

	// Init SVG sprite
	loadSVG();

	// Init modals
	modals.init({
		modalActiveClass: activeClass,
		preventBGScroll: true,
		preventBGScrollHtml: true,
		preventBGScrollBody: true,
    backspaceClose: true,
		callbackOpen: function (toggle, modal) {
			var video = modal.querySelector('iframe');

			if (video) {
				// Pause All Animations
				pauseAnimation();

				// Pause any music playing
				pauseMusic();

				// Start video playback
				video.src += '&autoplay=1';
			}
		},
		callbackClose: function (toggle, modal) {
			var video = modal.querySelector('iframe');
			if (video) {

				// End video playback
				video.src = video.src.replace('&autoplay=1', '');

				// Resume playing theme song
				// if (themeSongActive) {
				// 	themeSong.play();
				// }

			}
		}
	});

	// Listen for click event
  window.addEventListener('click', clickEventHandler, false);
  
  // Listen for keyup event
  window.addEventListener('keyup', keyupEventHandler, false);

	// Listen for lazysizes unveil event
	document.addEventListener('lazybeforeunveil', lazyBeforeUnveilHandler, false);

	// Listen for clicks on playlist iframe
	window.addEventListener('blur', function(){
		if(document.activeElement.id == 'playlist'){

			// Pause All Animations
			pauseAnimation();

			// Pause any music playing
			pauseMusic();

			// Get theme music toggle
			// var toggle = tweens.theme.toggle;

			// if (!toggle.classList.contains(inactiveClass)) {
			// 	updateToggle(toggle);
			// }
		}
	});

	// Listen for ended event
	for(var key in tweens) {
		tweens[key].audio.addEventListener('ended', endedEventHandler, false);
	}

})();